import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import ReactMarkdown from 'react-markdown'
import TurndownService from 'turndown'
import { cleanBlogHtml } from './atlasBlogHtml'

const turndown = new TurndownService({ headingStyle: 'atx', bulletListMarker: '-' })

export const htmlToBlogMarkdown = (html: string): string =>
  turndown.turndown(cleanBlogHtml(html))

const markdownLinkUri = (uri: string): string => {
  const absolute = normalizeBlogLink(uri)
  if (absolute) return absolute
  const relative = uri.trim()
  return /^[a-z][a-z\d+.-]*:/i.test(relative) || /^[/\\]{2}/.test(relative) || relative.startsWith('\\')
    ? ''
    : relative
}

export const markdownToBlogHtml = (markdown: string): string =>
  cleanBlogHtml(renderToStaticMarkup(
    <ReactMarkdown transformLinkUri={markdownLinkUri}>{markdown}</ReactMarkdown>
  ))

export const normalizeBlogLink = (input: string): string | null => {
  try {
    const url = new URL(input.trim())
    if (!['http:', 'https:', 'mailto:'].includes(url.protocol)) return null
    if (url.protocol === 'mailto:' && !url.pathname) return null
    return url.href
  } catch (_) {
    return null
  }
}

const escapeMarkdownLabel = (value: string): string => value.replace(/([\\[\]*_`])/g, '\\$1')
const markdownDestination = (url: string): string => `<${url.replace(/</g, '%3C').replace(/>/g, '%3E')}>`

export const blogMarkdownLink = (label: string, url: string): string =>
  `[${escapeMarkdownLabel(label || url)}](${markdownDestination(url)})`

export const blogMarkdownImage = (alt: string, url: string): string =>
  `![${escapeMarkdownLabel(alt)}](${markdownDestination(url)})`
